import { get, find } from "lodash";
import { CONTRACT_TYPES } from "@/constants/bookings";

export const APPLICATION_STATUSES = {
  LONGLIST: "longlist",
  SHORTLISTED: "shortlisted",
  APPROVED: "approved",
  REJECTED: "rejected",
  ALLOCATED: "allocated",
  UNALLOCATED: "unallocated",
  SUBMITTED: "submitted",
  UNSUBMITTED: "unsubmitted",
  CONFIRMED: "confirmed",
  WITHDRAWN: "withdrawn",
  DRAFT: "draft"
};

export const COMPILANCE_STATUSES = {
  INCOMPLETE: "incomplete",
  PARTIAL: "partial",
  COMPLETE: "complete"
};

export const BOOKING_STATUS = {
  LIVE: "live",
  PENDING: "pending-approval",
  CANCELLED: "cancelled"
};

export const getColorByStatus = status => {
  const {
    SHORTLISTED,
    APPROVED,
    REJECTED,
    ALLOCATED,
    CONFIRMED,
    WITHDRAWN
  } = APPLICATION_STATUSES;

  const { PARTIAL, COMPLETE } = COMPILANCE_STATUSES;
  const { LIVE, PENDING, CANCELLED } = BOOKING_STATUS;

  switch (status.toLowerCase()) {
    case CONFIRMED:
    case COMPLETE:
    case LIVE:
      return "green";
    case APPROVED:
      return "blue";
    case SHORTLISTED:
    case PARTIAL:
    case PENDING:
      return "yellow";
    case ALLOCATED:
      return "purple";
    case REJECTED:
    case WITHDRAWN:
    case CANCELLED:
      return "red";
    default:
      return "gray";
  }
};

export const groupByPropertyName = (items, propertyName) =>
  items.reduce((grouped, item) => {
    const groupedByProperty = grouped[item[propertyName]];
    if (!groupedByProperty) {
      grouped[item[propertyName]] = [item];
    } else {
      grouped[item[propertyName]] = [...groupedByProperty, item];
    }
    return grouped;
  }, {});

export const getApplicationActionIcon = action => {
  switch (action) {
    case "withdraw":
      return "mdi-account-arrow-left-outline";
    case "reject":
      return "mdi-thumb-down-outline";
    case "request-interview":
      return "mdi-card-account-phone-outline";
    case "approve":
      return "mdi-check";
    case "shortlist":
      return "mdi-clipboard-text-outline";
    default:
      return "request-interview";
  }
};

export const getContractLabel = value => {
  return get(find(CONTRACT_TYPES, { value }), "label");
};
